import type { Project } from '@/types/content'
import { ProjectCard } from './ProjectCard'
import styles from './ProjectGrid.module.css'

interface ProjectGridProps {
  projects: readonly Project[]
  /**
   * `showcase` is the home arrangement — two featured cards above three
   * smaller ones. `uniform` is the project index: every card at the Big size,
   * two per row.
   */
  layout?: 'showcase' | 'uniform'
}

/**
 * Arranges project cards. Which projects appear is the caller's decision;
 * this decides only how they sit on the page.
 */
export const ProjectGrid = ({ projects, layout = 'uniform' }: ProjectGridProps) => {
  if (layout === 'uniform') {
    return (
      <div className={styles.uniformGrid}>
        {projects.map((project) => (
          <ProjectCard key={project.slug} project={project} />
        ))}
      </div>
    )
  }

  const featured = projects.filter((project) => project.featured)
  const secondary = projects.filter((project) => !project.featured)

  return (
    <div className={styles.stack}>
      {featured.length > 0 && (
        <div className={styles.featuredRow}>
          {featured.map((project) => (
            <ProjectCard key={project.slug} project={project} />
          ))}
        </div>
      )}
      {secondary.length > 0 && (
        <div className={styles.secondaryRow}>
          {secondary.map((project) => (
            <ProjectCard key={project.slug} project={project} size="small" />
          ))}
        </div>
      )}
    </div>
  )
}
